import script from "./FaultFont.vue?vue&type=script&setup=true&lang=js"
export * from "./FaultFont.vue?vue&type=script&setup=true&lang=js"

import "./FaultFont.vue?vue&type=style&index=0&id=cc7055aa&lang=css"

const __exports__ = script;

export default __exports__